import { takeLatest, call, put } from "redux-saga/effects";
import Constant from "../../Constants/Constants";
import JwtAuthService from "../../../services/JwtAuthService";
import { Maintenance } from "../../Actions";

function* getMaintenanceHistory(action) {
  try {
    const response = yield call(JwtAuthService.getAPI, "", "api/Maintenance/getAll");
    const normalized = response.data || [];
    yield put(Maintenance.GetMaintenanceHistorySuccess(normalized));
    action?.payload?.onSuccess?.(normalized, response);
  } catch (error) {
    const errorMessage = error?.message || "Failed to load maintenance history.";
    yield put(Maintenance.GetMaintenanceHistoryFailure(errorMessage));
    action?.payload?.onError?.(errorMessage);
  }
}

function* submitMaintenance(action) {
  try {
    const request = action?.payload?.request;
    const response = yield call(JwtAuthService.postApi, request, "api/Maintenance/submit");
    if (response?.status === false) {
      const failMessage = response?.message || "Unable to save maintenance.";
      yield put(Maintenance.SubmitMaintenanceFailure(failMessage));
      action?.payload?.onError?.(failMessage);
      return;
    }
    yield put(Maintenance.SubmitMaintenanceSuccess(response));
    action?.payload?.onSuccess?.(response);
  } catch (error) {
    const errorMessage = error?.message || "Failed to save maintenance.";
    yield put(Maintenance.SubmitMaintenanceFailure(errorMessage));
    action?.payload?.onError?.(errorMessage);
  }
}

function* cancelMaintenance(action) {
  try {
    const id = action?.payload?.id;
    const response = yield call(JwtAuthService.postApi, { id }, "api/Maintenance/cancel");
    if (response?.status === false) {
      const failMessage = response?.message || "Unable to cancel maintenance.";
      yield put(Maintenance.CancelMaintenanceFailure(failMessage));
      action?.payload?.onError?.(failMessage);
      return;
    }
    yield put(Maintenance.CancelMaintenanceSuccess(response));
    action?.payload?.onSuccess?.(response);
  } catch (error) {
    const errorMessage = error?.message || "Failed to cancel maintenance.";
    yield put(Maintenance.CancelMaintenanceFailure(errorMessage));
    action?.payload?.onError?.(errorMessage);
  }
}

export function* MaintenanceSaga() {
  yield takeLatest(Constant.GET_MAINTENANCE_HISTORY_REQUEST, getMaintenanceHistory);
  yield takeLatest(Constant.SUBMIT_MAINTENANCE_REQUEST, submitMaintenance);
  yield takeLatest(Constant.CANCEL_MAINTENANCE_REQUEST, cancelMaintenance);
}
